import { IFeedbackModal } from 'components/layout/FeedbackModal';

export const FINDINGS_LIMIT_EXCEEDED_FEEDBACK_MODAL: IFeedbackModal = {
  type: 'error',
  title: 'Too Many Findings Detected',
  message: `The submitted exam contains too many detected findings, which prevents the system from generating the results successfully.
          Please split the video into two separate cropped parts and submit them individually to allow the analysis to be completed.`,
};
